// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
'use strict';
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class SourceGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.SOURCE_GROUP, null, pfixFieldSet);
    }
    getSource() {
        return this.GetValue(FieldsFactory.FIELD_SOURCE) || '';
    }
    getSourceId() {
        return this.GetValue(FieldsFactory.FIELD_SOURCE_ID) || 0;
    }
    getExternalSourceId() {
        return this.GetValue(FieldsFactory.FIELD_SOURCE_EXT_ID) || '';
    }
}
